import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector, connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { reduxForm, InjectedFormProps } from "redux-form";
import { RootState } from "../../store";
import {
  setEmail,
  setSelectedCountry,
  setSelectedRegion,
  setwizardPageNumber,
  setuserVideo,
  setfirstName,
  setlastName,
  setdateOfBirth,
  setdriverLicenseNumber,
  setidentityCardNumber,
  setpassportNumber,
  setotherIdentityNumber,
  setotherDocumentNumber,
  setUserID,
  setdriverLicenseFrontendPic,
  setdriverLicenseBackendPic,
  setidentityCardFrontendPic,
  setidentityCardBackendPic,
  setpassportFrontendPic,
  setpassportBackendPic,
  setotherIdentityFrontendPic,
  setotherIdentityBackendPic,
} from "../../authslice";
import { ToastBox, notifyError, notifySuccess } from "MyComponents/Toaster";
import { SpinnerBox } from "MyComponents/Spinner";
import SelfieCameraModal from "MyComponents/Camera/SelfieCameraModal";
import BackButton from "../../Includes/BackButton";
import axios from "axios";
import config from "../../../config";
import { isFileWithinSizeLimit, isBase64WithinSizeLimit, fileSizeErrorMessage } from "Utils/fileValidation";
import { compressBase64Image } from "Utils/imageCompression";

// Images
import doc_icon from "../../../images/upload_doc_icon.png";
import identity_card_banner from "../../../images/identity_card_banner.png";
import face_verify_middle_banner from "../../../images/face_verify_middle_banner.png";
import user_img from "../../../images/test_img.png";
import red_cross_icon from "../../../images/circle_cross.png";
import QRCode from "react-qr-code";
import VideoCaptureModal from "MyComponents/Camera/VideoCaptureModal";
import { ReactComponent as VideoIcon } from "../../../images/videoIcon.svg";
import Spacer from "MyComponents/UI/Spacer";
import { updatePersonalKycDraftStep } from "Utils/personalKycDraft";
import { getUserID } from "Utils/user";
import { useTranslation } from "react-i18next";

interface Props {}

const UploadVideoForFaceVerify: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props) => {
  const { t } = useTranslation();
  const { handleSubmit } = props;
  const dispatch = useDispatch();
  const userID = useSelector((state: RootState) => state.auth.userID);
  const kycToken = useSelector((state: RootState) => state.auth.kycToken);
  const BaseURL = process.env.REACT_APP_BASE_URL;
  const page = useSelector((state: RootState) => state.auth.wizardPageNumber);
  const theme = useSelector((state: RootState) => state.theme.theme);
  const driverLicenseFrontendPic = useSelector(
    (state: RootState) => state.auth.driverLicenseFrontendPic
  );
  const identityCardFrontendPic = useSelector(
    (state: RootState) => state.auth.identityCardFrontendPic
  );
  const passportFrontendPic = useSelector(
    (state: RootState) => state.auth.passportFrontendPic
  );
  const driverLicenseBackendPic = useSelector(
    (state: RootState) => state.auth.driverLicenseBackendPic
  );
  const identityCardBackendPic = useSelector(
    (state: RootState) => state.auth.identityCardBackendPic
  );
  const passportBackendPic = useSelector(
    (state: RootState) => state.auth.passportBackendPic
  );
  const selectedDocumentNumberDriverLicense = useSelector(
    (state: RootState) => state.auth.selectedDocumentNumberDriverLicense
  );
  const selectedDocumentNumberIdentityCard = useSelector(
    (state: RootState) => state.auth.selectedDocumentNumberIdentityCard
  );
  const selectedDocumentNumberPassport = useSelector(
    (state: RootState) => state.auth.selectedDocumentNumberPassport
  );
  const dob = useSelector((state: RootState) => state.auth.dateofBirth);
  const otherIdentityFrontendPic = useSelector(
    (state: RootState) => state.auth.otherIdentityFrontendPic
  );
  const otherIdentityBackendPic = useSelector(
    (state: RootState) => state.auth.otherIdentityBackendPic
  );
  const selectedDocumentNumberOtherIdentity = useSelector(
    (state: RootState) => state.auth.selectedDocumentNumberOtherIdentity
  );
  const selectedDocumentNumberOtherDocument = useSelector(
    (state: RootState) => state.auth.selectedDocumentNumberOtherDocument
  );
  const email = useSelector((state: RootState) => state.auth.email);
  const userVideo = useSelector((state: RootState) => state.auth.userVideo);
  const userFirstName = useSelector((state: RootState) => state.auth.firstName);
  const userLastName = useSelector((state: RootState) => state.auth.lastName);

  const [showModal1, setShowModal1] = useState(false);
  const [srcModal1, setSrcModal1] = useState<string | null>(
    userVideo && !userVideo.startsWith("http") ? `data:image/jpeg;base64,${userVideo}` : null
  );
  const [validated, setValidated] = useState(false);
  const [uploadedVideoUrl, setUploadedVideoUrl] = useState<string | null>(null);
  const [uploadedSelfie, setUploadedSelfie] = useState<Blob | null>(null);
  const [uploadedVideoName, setUploadedVideoName] = useState<string | null>(null);
  const [uploadedVideoSize, setUploadedVideoSize] = useState<number | null>(null);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [videoVerified, setVideoVerified] = useState(false);

  const verifydocument_baseURL =
    config.NODE_API_BASE_URL + "/idAnalyzer/documentAndFaceVerification";
  const uploaddocument_baseURL =
    config.NODE_API_BASE_URL + "/wso2/updateUserDocument";

  let verificationCount = 0;
  let driverLicenseDocAuthScore = "";
  let driverLicenseFaceMatchScore = "";
  let identityCardDocAuthScore = "";
  let identityCardFaceMatchScore = "";
  let passportDocAuthScore = "";
  let passportFaceMatchScore = "";

  const startLoading = () => setLoading(true);
  const stopLoading = () => setLoading(false);

  useEffect(() => {
    document.body.style.overflow = loading ? "hidden" : "visible";
  }, [loading]);

  const handleShowModal1 = () => setShowModal1(true);
  const handleCloseModal1 = () => setShowModal1(false);

  const updateSrcModal1 = (newState: string) => {
    const parts = newState.split(",");
    if (parts.length === 2) {
      const base64UserSelfie: any = parts[1];
      setUploadedSelfie(base64UserSelfie);
      dispatch(setuserVideo(base64UserSelfie));
      setSrcModal1(newState);
    }
  };

  const handleModal1CrossIconClick = () => {
    setSrcModal1(null);
    setShowModal1(false);
  };

  const handleVideoUpload = (data: any) => {
    setVideoVerified(true);
    setUploadedSelfie(data.videoBlob);
    setUploadedVideoUrl(data.videoUrl);
    setUploadedVideoName(data.videoName);
    setUploadedVideoSize(data.videoSize);

    const reader = new FileReader();
    reader.readAsDataURL(data.videoBlob);
    reader.onloadend = function () {
      const dataURL = reader.result as string;
      const base64String: any = dataURL.split(",")[1];
      setUploadedSelfie(base64String);
      dispatch(setuserVideo(base64String));
    };
  };

  const handleDeleteVideo = (e: React.MouseEvent) => {
    e.stopPropagation();
    setUploadedVideoUrl(null);
    setUploadedVideoName(null);
    setUploadedVideoSize(null);
    setVideoVerified(false);
    dispatch(setuserVideo(""));
  };

  const verifyDocument = async (
    document_file: string,
    document_type: string
  ) => {
    try {
      const formData = new FormData();
      const b64toBlob = (b64Data: string, contentType='') => {
        try {
          const byteCharacters = atob(b64Data);
          const byteArrays = [];
          for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }
            byteArrays.push(new Uint8Array(byteNumbers));
          }
          return new Blob(byteArrays, {type: contentType});
        } catch (e) {
          console.error("Failed to convert base64 to blob", e);
          return new Blob([], {type: contentType});
        }
      };

      const processedDocFile = isBase64WithinSizeLimit(document_file)
        ? document_file
        : await compressBase64Image(document_file);

      const videoBlob = b64toBlob(userVideo, 'video/webm');
      if (!isFileWithinSizeLimit(videoBlob)) {
        notifyError(fileSizeErrorMessage("Selfie video"));
        return null;
      }

      formData.append('document_file', b64toBlob(processedDocFile, 'image/jpeg'), 'doc.jpg');
      formData.append('user_video', videoBlob, 'video.webm');
      formData.append('document_type', document_type);
      formData.append('user_ID', userID ? userID.toString() : '');

      const verify_Document = await axios.post(verifydocument_baseURL, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (verify_Document.status === 200) {
        return verify_Document.data;
      } else {
        notifyError("Error Verify Document");
        return null;
      }
    } catch (error: any) {
      if (error?.response?.status === 413) {
        notifyError("Video is too large. Please record a shorter video (max 5 seconds).");
      } else {
        notifyError("Verification failed.");
      }
      console.error("Verification error:", error);
      return null;
    }
  };

  const dataURLToBlob = (dataURL: string) => {
    if (!dataURL) return null;
    const parts = dataURL.includes(",") ? dataURL.split(",") : [null, dataURL];
    const byteString = atob(parts[1] || "");
    const mimeString = parts[0] ? parts[0].split(":")[1].split(";")[0] : "image/jpeg";
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  const uploadDocuments = async (
    userId: string,
    drivingLicenseFront: string,
    drivingLicenseBack: string,
    identityCardFront: string,
    identityCardBack: string,
    passportFront: string,
    passportBack: string,
    otherIdentityFront: string,
    otherIdentityBack: string,
    driverLicenseDocAuthScore: string,
    driverLicenseFaceMatchScore: string,
    identityCardDocAuthScore: string,
    identityCardFaceMatchScore: string,
    passportDocAuthScore: string,
    passportFaceMatchScore: string,
    otherIdDocAuthScore: string,
    otherIdFaceMatchScore: string,
    otherDocDocAuthScore: string,
    otherDocFaceMatchScore: string,
    selectedDocumentNumberDriverLicense: string,
    selectedDocumentNumberIdentityCard: string,
    selectedDocumentNumberPassport: string,
    selectedDocumentNumberOtherIdentity: string,
    selectedDocumentNumberOtherDocument: string,
    dob: string
  ) => {
    try {
      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("driverLicenseDocAuthScore", driverLicenseDocAuthScore);
      formData.append("driverLicenseFaceMatchScore", driverLicenseFaceMatchScore);
      formData.append("identityCardDocAuthScore", identityCardDocAuthScore);
      formData.append("identityCardFaceMatchScore", identityCardFaceMatchScore);
      formData.append("passportDocAuthScore", passportDocAuthScore);
      formData.append("passportFaceMatchScore", passportFaceMatchScore);
      formData.append("otherIdDocAuthScore", otherIdDocAuthScore);
      formData.append("otherIdFaceMatchScore", otherIdFaceMatchScore);
      formData.append("otherDocDocAuthScore", otherDocDocAuthScore);
      formData.append("otherDocFaceMatchScore", otherDocFaceMatchScore);
      formData.append("selectedDocumentNumberDriverLicense", selectedDocumentNumberDriverLicense);
      formData.append("selectedDocumentNumberIdentityCard", selectedDocumentNumberIdentityCard);
      formData.append("selectedDocumentNumberPassport", selectedDocumentNumberPassport);
      formData.append("selectedDocumentNumberOtherIdentity", selectedDocumentNumberOtherIdentity);
      formData.append("selectedDocumentNumberOtherDocument", selectedDocumentNumberOtherDocument);
      formData.append("dob", dob);

      const appendFile = async (fieldName: string, data: string) => {
        if (!data) return;

        const isVideo = fieldName === "selfieVideo";
        const processedData = !isVideo && !isBase64WithinSizeLimit(data)
          ? await compressBase64Image(data)
          : data;

        const blob = dataURLToBlob(processedData);
        if (!blob) return;

        if (isVideo && !isFileWithinSizeLimit(blob)) {
          notifyError(fileSizeErrorMessage("Selfie video"));
          throw new Error("SELFIE_VIDEO_TOO_LARGE");
        }

        const ext = isVideo ? "webm" : "jpg";
        formData.append(fieldName, blob, `${fieldName}.${ext}`);
      };

      await appendFile("drivingLicenseFront", drivingLicenseFront);
      await appendFile("drivingLicenseBack", drivingLicenseBack);
      await appendFile("identityCardFront", identityCardFront);
      await appendFile("identityCardBack", identityCardBack);
      await appendFile("passportFront", passportFront);
      await appendFile("passportBack", passportBack);
      await appendFile("otherIdentityFront", otherIdentityFront);
      await appendFile("otherIdentityBack", otherIdentityBack);
      await appendFile("selfieVideo", userVideo);

      const response = await axios.post(uploaddocument_baseURL, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (response.status === 200) {
        return response.data;
      }
      return { error: "Error Verify Document" };
    } catch (error: any) {
      if (error?.response?.status === 413) {
        return { error: "entity_too_large" };
      }
      console.error("Error uploading documents:", error);
      return { error: "Error Verify Document" };
    }
  };

  const normalize = (str: string) =>
    str?.toLowerCase().replace(/[^a-z]/g, "").trim();

  const levenshtein = (a: string, b: string) => {
    const matrix = [];
    for (let i = 0; i <= b.length; i++) matrix[i] = [i];
    for (let j = 0; j <= a.length; j++) matrix[0][j] = j;
    for (let i = 1; i <= b.length; i++) {
      for (let j = 1; j <= a.length; j++) {
        if (b.charAt(i - 1) === a.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1
          );
        }
      }
    }
    return matrix[b.length][a.length];
  };

  const isSimilar = (a: string, b: string) => {
    if (!a || !b) return false;
    const dist = levenshtein(normalize(a), normalize(b));
    const maxLen = Math.max(normalize(a).length, normalize(b).length);
    const score = 1 - dist / maxLen;
    return score >= 0.75;
  };

  const specialMatch = (a: string, b: string) => {
    if (!a || !b) return false;
    const nA = normalize(a);
    const nB = normalize(b);
    return nA.slice(1) === nB || nB.slice(1) === nA;
  };

  const submitForm = async () => {
    if (!videoVerified || !checkboxChecked || !userVideo) {
      setValidated(true);
      return;
    }

    let currentUserID = userID;

    if (!currentUserID && email) {
      console.log("UserID missing in UploadVideoForFaceVerify, resolving...");
      const resolvedID = await getUserID(email);
      if (resolvedID && resolvedID !== 0) {
        currentUserID = resolvedID;
        dispatch(setUserID(resolvedID));
      }
    }

    if (!currentUserID) {
      notifyError("User identification failed. Please contact support.");
      return;
    }

    startLoading();

    let dlDocAuthScore = "";
    let dlFaceMatchScore = "";
    let icDocAuthScore = "";
    let icFaceMatchScore = "";
    let pDocAuthScore = "";
    let pFaceMatchScore = "";
    let otherIdDocAuthScore = "";
    let otherIdFaceMatchScore = "";
    let otherDocDocAuthScore = "";
    let otherDocFaceMatchScore = "";

    if (passportFrontendPic) {
      const parts = passportFrontendPic.split(",");
      if (parts.length === 2) {
        const imageData = parts[1];
        const response = await verifyDocument(imageData, "passport");
        if (response && response.data) {
          const data = response.data;
          pFaceMatchScore = data.face_matching_confidence_score?.toString() || "";
          pDocAuthScore = data.document_authenticity_score?.toString() || "";
          if (data.document_number) dispatch(setpassportNumber(data.document_number));
          if (data.first_name && (!isSimilar(userFirstName, data.first_name) && !specialMatch(userFirstName, data.first_name))) {
            dispatch(setfirstName(data.first_name));
          }
          if (data.last_name && !isSimilar(userLastName, data.last_name)) {
            dispatch(setlastName(data.last_name));
          }
          if (data.dob) dispatch(setdateOfBirth(data.dob));
          if (data.country) dispatch(setSelectedCountry(data.country));
          if (data.state) dispatch(setSelectedRegion(data.state));
        }
      }
    }

    if (driverLicenseFrontendPic) {
      const parts = driverLicenseFrontendPic.split(",");
      if (parts.length === 2) {
        const imageData = parts[1];
        const response = await verifyDocument(imageData, "drivingLicense");
        if (response && response.data) {
          const data = response.data;
          dlFaceMatchScore = data.face_matching_confidence_score?.toString() || "";
          dlDocAuthScore = data.document_authenticity_score?.toString() || "";
          if (data.document_number) dispatch(setdriverLicenseNumber(data.document_number));
          if (data.first_name && (!isSimilar(userFirstName, data.first_name) && !specialMatch(userFirstName, data.first_name))) {
            dispatch(setfirstName(data.first_name));
          }
          if (data.last_name && !isSimilar(userLastName, data.last_name)) {
            dispatch(setlastName(data.last_name));
          }
          if (data.dob) dispatch(setdateOfBirth(data.dob));
          if (data.country) dispatch(setSelectedCountry(data.country));
          if (data.state) dispatch(setSelectedRegion(data.state));
        }
      }
    }

    if (identityCardFrontendPic) {
      const parts = identityCardFrontendPic.split(",");
      if (parts.length === 2) {
        const imageData = parts[1];
        const response = await verifyDocument(imageData, "identityCard");
        if (response && response.data) {
          const data = response.data;
          icFaceMatchScore = data.face_matching_confidence_score?.toString() || "";
          icDocAuthScore = data.document_authenticity_score?.toString() || "";
          if (data.document_number) dispatch(setidentityCardNumber(data.document_number));
          if (data.first_name && (!isSimilar(userFirstName, data.first_name) && !specialMatch(userFirstName, data.first_name))) {
            dispatch(setfirstName(data.first_name));
          }
          if (data.last_name && !isSimilar(userLastName, data.last_name)) {
            dispatch(setlastName(data.last_name));
          }
          if (data.dob) dispatch(setdateOfBirth(data.dob));
          if (data.country) dispatch(setSelectedCountry(data.country));
          if (data.state) dispatch(setSelectedRegion(data.state));
        }
      }
    }

    if (otherIdentityFrontendPic) {
      const parts = otherIdentityFrontendPic.split(",");
      if (parts.length === 2) {
        const imageData = parts[1];
        const response = await verifyDocument(imageData, "other");
        if (response && response.data) {
          const data = response.data;
          otherIdFaceMatchScore = data.face_matching_confidence_score?.toString() || "";
          otherIdDocAuthScore = data.document_authenticity_score?.toString() || "";
          if (data.document_number) dispatch(setotherIdentityNumber(data.document_number));
          if (data.first_name && (!isSimilar(userFirstName, data.first_name) && !specialMatch(userFirstName, data.first_name))) {
            dispatch(setfirstName(data.first_name));
          }
          if (data.last_name && !isSimilar(userLastName, data.last_name)) {
            dispatch(setlastName(data.last_name));
          }
          if (data.dob) dispatch(setdateOfBirth(data.dob));
          if (data.country) dispatch(setSelectedCountry(data.country));
          if (data.state) dispatch(setSelectedRegion(data.state));
        }
      }
    }

    try {
      const response = await uploadDocuments(
        currentUserID,
        driverLicenseFrontendPic,
        driverLicenseBackendPic,
        identityCardFrontendPic,
        identityCardBackendPic,
        passportFrontendPic,
        passportBackendPic,
        otherIdentityFrontendPic,
        otherIdentityBackendPic,
        dlDocAuthScore,
        dlFaceMatchScore,
        icDocAuthScore,
        icFaceMatchScore,
        pDocAuthScore,
        pFaceMatchScore,
        otherIdDocAuthScore,
        otherIdFaceMatchScore,
        otherDocDocAuthScore,
        otherDocFaceMatchScore,
        selectedDocumentNumberDriverLicense,
        selectedDocumentNumberIdentityCard,
        selectedDocumentNumberPassport,
        selectedDocumentNumberOtherIdentity,
        selectedDocumentNumberOtherDocument,
        dob
      );

      if (response.error === "entity_too_large") {
        notifyError("Video is too large. Please record a shorter video (max 5 seconds).");
        stopLoading();
        return;
      }

      if (response.status === 1) {
        if (response.data && response.data.urls) {
          const urls = response.data.urls;
          if (urls.drivingLicenseFront) dispatch(setdriverLicenseFrontendPic(urls.drivingLicenseFront));
          if (urls.drivingLicenseBack) dispatch(setdriverLicenseBackendPic(urls.drivingLicenseBack));
          if (urls.identityCardFront) dispatch(setidentityCardFrontendPic(urls.identityCardFront));
          if (urls.identityCardBack) dispatch(setidentityCardBackendPic(urls.identityCardBack));
          if (urls.passportFront) dispatch(setpassportFrontendPic(urls.passportFront));
          if (urls.passportBack) dispatch(setpassportBackendPic(urls.passportBack));
          if (urls.otherIdentityFront) dispatch(setotherIdentityFrontendPic(urls.otherIdentityFront));
          if (urls.otherIdentityBack) dispatch(setotherIdentityBackendPic(urls.otherIdentityBack));
          if (urls.selfieVideo) dispatch(setuserVideo(urls.selfieVideo));
        }

        dispatch(setwizardPageNumber(page + 1));
        localStorage.setItem('pageNumber', `${page + 1}`);

        if (currentUserID) {
          updatePersonalKycDraftStep(currentUserID, 'faceVerification', {
            userVideo: userVideo,
            dlDocAuthScore,
            dlFaceMatchScore,
            icDocAuthScore,
            icFaceMatchScore,
            pDocAuthScore,
            pFaceMatchScore,
            otherIdDocAuthScore,
            otherIdFaceMatchScore
          });
          updatePersonalKycDraftStep(currentUserID, 'wizardState', { pageNumber: page + 1 });
        }
      } else {
        notifyError("Error Verify Document");
      }
    } catch (error) {
      console.error("Form submission error:", error);
      notifyError("An unexpected error occurred.");
    } finally {
      stopLoading();
    }
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxChecked(e.target.checked);
  };

  return (
    <>
      <ToastBox />
      {loading && <SpinnerBox />}

      <VideoCaptureModal
        show={showModal1}
        handleClose={handleCloseModal1}
        title="Face Verification"
        onVideoUpload={handleVideoUpload}
      />

      <Container fluid className={`${theme === "dark" && "bg-black"} bg-sky`}>
        <Row>
          <Col md={12}>
            <div className="">
              <Row className="px-2 px-md-5">
                <Col md={10} className="py-2">
                  <BackButton />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Row className="px-2 px-md-5">
                    <Col xs={2} md={1} className="px-2 px-md-4">
                      <img src={doc_icon} width={50} alt="doc icon" />
                    </Col>
                    <Col xs={10} md={10} className="ps-0">
                      <h3 className="text-start">{t('kyc.take_video_title')}</h3>
                      <p className="fw-normal text-secondary">{t('kyc.take_video_secure')}</p>
                    </Col>
                  </Row>
                  <Form noValidate={true} validated={validated} onSubmit={handleSubmit(submitForm)}>
                    <Col xs={12} md={10} className="mb-5">
                      <Row className="px-2 px-md-5">
                        <Col xs={12} md={5} className="px-2 px-md-4">
                          <div onClick={handleShowModal1}>
                            <p className="fw-bold mt-2">{t('kyc.take_selfie_video')}</p>

                            <div
                              className={`row justify-content-center align-items-center text-center p-4 rounded ${uploadedVideoSize ? "d-none" : ""}`}
                              style={{
                                background: theme === "dark" ? "#1a1a1a" : "#EDF7F3",
                                border: `2px dashed ${validated && !videoVerified ? "#dc3545" : "#00D084"}`,
                                cursor: "pointer",
                                minHeight: "200px",
                              }}
                            >
                              <div className="col-12">
                                <i
                                  className="fa-solid fa-video mb-3"
                                  style={{ fontSize: "40px", color: "#00D084" }}
                                ></i>

                                <h6 className={`fw-bold mb-2 ${theme === "dark" ? "text-light" : ""}`}>{t('kyc.record_video_prompt')}</h6>

                                <p className="text-muted small mb-3">{t('kyc.video_specs')}</p>

                                <button className="btn btn-primary px-4 mb-3">{t('kyc.take_video_btn')}</button>

                                <p className="text-muted small mb-0">{t('kyc.video_formats')}</p>
                              </div>
                              {validated && !videoVerified && (
                                <div className="text-danger small mt-2 fw-bold">
                                  {t('kyc.video_verify_required')}
                                </div>
                              )}
                            </div>

                            <div className={`${!uploadedVideoSize ? "d-none" : "show"} mt-4 mb-4`}>
                              <div
                                className={`p-4 rounded-4 shadow-sm border ${theme === "dark" ? "bg-dark" : ""}`}
                                style={{
                                  border: theme === "dark" ? "1px solid #444" : "1px solid #e0eef2",
                                  background: theme === "dark" ? "#1a1a1a" : "linear-gradient(145deg, #ffffff, #f8fbff)",
                                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)"
                                }}
                              >
                                <Row className="align-items-center">
                                  <Col md={2} className="text-center">
                                    <div
                                      className="d-inline-flex align-items-center justify-content-center rounded-circle shadow-sm"
                                      style={{
                                        width: "60px",
                                        height: "60px",
                                        backgroundColor: theme === "dark" ? "#1a2e24" : "#E6FAF4",
                                        border: theme === "dark" ? "1px solid #00D084" : "1px solid #9DEBE0"
                                      }}
                                    >
                                      <VideoIcon />
                                    </div>
                                  </Col>
                                  <Col md={10} className="ps-md-4 mt-3 mt-md-0">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <h6 className="m-0 fw-bold letter-spacing-fix">{t('kyc.selfie_captured')}</h6>
                                      <span className="badge rounded-pill bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-3 py-2">
                                        <i className="fa-solid fa-circle-check me-1"></i> {t('kyc.video_ready')}
                                      </span>
                                    </div>
                                    <p className="small text-secondary mb-3">
                                      <i className="fa-solid fa-file-video me-1"></i> video.webm
                                      <span className="mx-2 text-muted">|</span>
                                      <i className="fa-solid fa-database me-1"></i> {((uploadedVideoSize || 0) / 1024).toFixed(2)} KB
                                    </p>
                                    <div className="d-flex flex-column flex-md-row gap-2">
                                      <Button
                                        variant="primary"
                                        size="sm"
                                        className="rounded-pill px-4 py-2 fw-semibold shadow-sm"
                                        onClick={handleShowModal1}
                                      >
                                        <i className="fa-solid fa-camera-rotate me-1"></i> {t('kyc.retake_video')}
                                      </Button>
                                      <Button
                                        variant="outline-danger"
                                        size="sm"
                                        className="rounded-pill px-4 py-2 fw-semibold border-2"
                                        onClick={handleDeleteVideo}
                                      >
                                        <i className="fa-solid fa-trash-can me-1"></i> {t('common.delete')}
                                      </Button>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </div>

                          <Row className={`mt-3 mb-3 ${theme === "light" && "bg-sky"}`}>
                            <Col md={3}>
                              <p className="fw-light text-secondary">{t('kyc.example_label')}</p>
                              <img src={user_img} width={100} alt="example" />
                            </Col>
                            <Col md={1}></Col>
                            <Col md={8}>
                              <p className="fw-light text-secondary">{t('kyc.please_consider')}</p>
                              <img
                                className="mb-3"
                                src={face_verify_middle_banner}
                                width={260}
                                alt="face verify"
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col md={3} className="d-none d-md-block">
                          <p className="fw-bold mt-2 ms-2">{t('kyc.qr_code')}</p>
                          <Row className={`mb-5 ms-2 py-3 d-flex justify-content-center align-items-center rounded-3 ${theme === "light" && "bg-sky"}`}>
                            <div style={{ width: 256, margin: "20px auto 0" }}>
                              <QRCode
                                value={`${BaseURL}/kyc/personal/${userID}/${kycToken}`}
                                size={256}
                                style={{ width: "100%", height: "auto" }}
                              />
                            </div>
                            <p className="fw-normal fs-6 text-center mt-4">{t('kyc.scan_qr_mobile')}</p>
                            <p className="fw-normal text-secondary small text-center mb-5">{t('kyc.scan_mobile_desc')}</p>
                          </Row>
                        </Col>
                        <Col md={4} className="mt-4">
                          <Row
                            className={`justify-content-center rounded-3 mt-2 ms-2 p-3 ${theme === "light" && "bg-sky"}`}
                            style={{ border: "1px solid #E4ECF7" }}
                          >
                            <div className="text-center mb-2">
                              <img
                                src={identity_card_banner}
                                width={150}
                                height={120}
                                style={{ objectFit: "contain" }}
                                alt="banner"
                              />
                            </div>

                            <p className="fw-bold text-center mb-2">{t('kyc.face_verify_guidelines')}</p>

                            <p className="small text-secondary text-center mb-3">{t('kyc.face_verify_tips')}</p>

                            <div
                              className="rounded-3 p-3"
                              style={{
                                background: theme === "dark" ? "#1F1F1F" : "#EDF7F3",
                                border: "1px dashed #C9DAF8",
                              }}
                            >
                              <ul className="list-unstyled small text-secondary mb-0">
                                <li className="mb-2">✓ {t('kyc.face_well_lit')}</li>
                                <li className="mb-2">✓ {t('kyc.face_steady')}</li>
                                <li className="mb-2">✓ {t('kyc.face_visible')}</li>
                                <li className="mb-2">✓ {t('kyc.face_3_5_sec')}</li>
                                <li className="mb-2">✓ {t('kyc.face_follow_instructions')}</li>
                                <li>✓ {t('kyc.face_review')}</li>
                              </ul>
                            </div>
                          </Row>
                        </Col>
                      </Row>
                      <div className="row container-fluid ms-4">
                        <div className="form-check p-0">
                          <Form.Check
                            required
                            type="checkbox"
                            id="flexCheckDefault"
                            label={
                              <span className="text-secondary small">
                                {t('kyc.face_id_agree')}
                              </span>
                            }
                            onChange={handleCheckboxChange}
                            isInvalid={validated && !checkboxChecked}
                            feedback={t('kyc.must_agree')}
                            feedbackType="invalid"
                          />
                        </div>
                      </div>
                      <Row className="justify-content-between">
                        <Col md={12} className="mb-3">
                          <Button
                            type="submit"
                            className="btn btn-primary mt-3 rounded-5 me-5 float-end"
                          >
                            {t('common.continue')}
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Form>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  form: "wizard",
  enableReinitialize: true,
})(UploadVideoForFaceVerify);

export default connect(null)(form);
